var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.122,
    height: 119.939,
    viewBox: "0 0 171.122 119.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_933",
    "data-name": "Grupo 933",
    transform: "translate(11616.736 -12865.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_spreadsheet_re_cn18",
    transform: "translate(-11616.736 12865.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16009",
    "data-name": "Trazado 16009",
    d: "M558.219,270.439H439.684a1.6,1.6,0,0,1-1.6-1.6V195.42h121.74v73.417A1.6,1.6,0,0,1,558.219,270.439Z",
    transform: "translate(-388.7 -192.335)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16010",
    "data-name": "Trazado 16010",
    d: "M566.762,289.241H455.179a1.622,1.622,0,0,1-1.62-1.62V227.16a1.622,1.622,0,0,1,1.62-1.62H566.762a1.622,1.622,0,0,1,1.62,1.62v60.461A1.622,1.622,0,0,1,566.762,289.241Z",
    transform: "translate(-400.719 -215.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16011",
    "data-name": "Trazado 16011",
    d: "M559.589,186.964H437.849v-3.75a1.6,1.6,0,0,1,1.6-1.6H557.987a1.6,1.6,0,0,1,1.6,1.6Z",
    transform: "translate(-388.52 -181.612)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_278",
    "data-name": "Elipse 278",
    cx: 0.957,
    cy: 0.957,
    r: 0.957,
    transform: "translate(52.304 1.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_279",
    "data-name": "Elipse 279",
    cx: 0.957,
    cy: 0.957,
    r: 0.957,
    transform: "translate(55.937 1.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_280",
    "data-name": "Elipse 280",
    cx: 0.957,
    cy: 0.957,
    r: 0.957,
    transform: "translate(59.57 1.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2361",
    "data-name": "Rect\\xE1ngulo 2361",
    width: 11.501,
    height: 5.09,
    transform: "translate(64.308 20.657)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2362",
    "data-name": "Rect\\xE1ngulo 2362",
    width: 11.501,
    height: 5.09,
    transform: "translate(87.309 31.215)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2363",
    "data-name": "Rect\\xE1ngulo 2363",
    width: 11.501,
    height: 5.09,
    transform: "translate(64.308 47.052)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2364",
    "data-name": "Rect\\xE1ngulo 2364",
    width: 11.501,
    height: 5.09,
    transform: "translate(87.309 57.61)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2365",
    "data-name": "Rect\\xE1ngulo 2365",
    width: 11.501,
    height: 5.09,
    transform: "translate(144.623 62.889)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2366",
    "data-name": "Rect\\xE1ngulo 2366",
    width: 11.501,
    height: 5.09,
    transform: "translate(133.122 41.773)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2367",
    "data-name": "Rect\\xE1ngulo 2367",
    width: 23.001,
    height: 5.09,
    transform: "translate(98.809 41.773)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2368",
    "data-name": "Rect\\xE1ngulo 2368",
    width: 23.001,
    height: 5.09,
    transform: "translate(98.809 15.19)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16012",
    "data-name": "Trazado 16012",
    d: "M453.414,225.122v63.913H568.419V225.122Zm114.628,5.295H556.956V225.5h11.086Zm-68.4,37.062v-4.918h22.548v4.918Zm22.548.377v4.918H499.642v-4.918Zm0-21.178V251.6H499.642v-4.918Zm-22.548-.377v-4.918h22.548V246.3Zm0,10.589v-4.918h22.548v4.918Zm22.548.377v4.918H499.642v-4.918ZM499.265,251.6H488.18v-4.918h11.086Zm0,.377v4.918H488.18v-4.918Zm0,5.295v4.918H488.18v-4.918Zm0,5.295v4.918H488.18v-4.918Zm23.3,0h11.086v4.918H522.568Zm0-.377v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086V251.6Zm0-5.295v-4.918h11.086V246.3Zm0-5.295v-4.918h11.086v4.918Zm-.377,0H499.642v-4.918h22.548Zm-22.926,0H488.18v-4.918h11.086Zm0,.377V246.3H488.18v-4.918ZM487.8,246.3H476.717v-4.918H487.8Zm0,.377V251.6H476.717v-4.918Zm0,5.295v4.918H476.717v-4.918Zm0,5.295v4.918H476.717v-4.918Zm0,5.295v4.918H476.717v-4.918Zm0,5.295v4.918H476.717v-4.918Zm.377,0h11.086v4.918H488.18Zm11.086,5.295v4.918H488.18v-4.918Zm.377,0h22.548v4.918H499.642Zm22.926,0h11.086v4.918H522.568Zm0-.377v-4.918h11.086v4.918Zm11.463-4.918h11.086v4.918H534.031Zm0-.377v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086V251.6Zm0-5.295v-4.918h11.086V246.3Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.917h11.086v4.917Zm-.377,0H522.568v-4.917h11.086Zm-11.463,0H499.642v-4.917h22.548Zm-22.926,0H488.18v-4.917h11.086Zm-11.463,0H476.717v-4.917H487.8Zm0,.377v4.918H476.717v-4.918Zm-11.463,4.918H465.254v-4.918H476.34Zm0,.377V246.3H465.254v-4.918Zm0,5.295V251.6H465.254v-4.918Zm0,5.295v4.918H465.254v-4.918Zm0,5.295v4.918H465.254v-4.918Zm0,5.295v4.918H465.254v-4.918Zm0,5.295v4.918H465.254v-4.918Zm0,5.295v4.918H465.254v-4.918Zm.377,0H487.8v4.918H476.717Zm11.086,5.295v4.918H476.717v-4.918Zm.377,0h11.086v4.918H488.18Zm11.463,0h22.548v4.918H499.642Zm22.926,0h11.086v4.918H522.568Zm11.463,0h11.086v4.918H534.031Zm0-.377v-4.918h11.086v4.918Zm11.463-4.918h11.086v4.918H545.494Zm0-.377v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086V251.6Zm0-5.295v-4.918h11.086V246.3Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.917h11.086v4.917Zm0-5.295V225.5h11.086v4.918Zm-.377,0H534.031V225.5h11.086Zm-11.463,0H522.568V225.5h11.086Zm-11.463,0H499.642V225.5h22.548Zm-22.926,0H488.18V225.5h11.086Zm-11.463,0H476.717V225.5H487.8Zm-11.463,0H465.254V225.5H476.34Zm0,.377v4.918H465.254v-4.917Zm-11.463,4.918H453.791v-4.917h11.086Zm0,.377v4.918H453.791v-4.918Zm0,5.295V246.3H453.791v-4.918Zm0,5.295V251.6H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm0,5.295v4.918H453.791v-4.918Zm.377,0H476.34v4.918H465.254Zm11.086,5.295v4.918H465.254v-4.918Zm.377,0H487.8v4.918H476.717Zm11.463,0h11.086v4.918H488.18Zm11.463,0h22.548v4.918H499.642Zm22.926,0h11.086v4.918H522.568Zm11.463,0h11.086v4.918H534.031Zm11.463,0h11.086v4.918H545.494Zm0-.377v-4.918h11.086v4.918Zm11.463-4.918h11.086v4.918H556.956Zm0-.377v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.918h11.086V251.6Zm0-5.295v-4.918h11.086V246.3Zm0-5.295v-4.918h11.086v4.918Zm0-5.295v-4.917h11.086v4.917ZM464.877,225.5v4.918H453.791V225.5Zm-11.086,58.241h11.086v4.918H453.791Zm103.165,4.918v-4.918h11.086v4.918Z",
    transform: "translate(-400.607 -215.4)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16013",
    "data-name": "Trazado 16013",
    d: "M279.138,378.835s-5.818-1.341-9.018,1.117S274.192,388,274.192,388Z",
    transform: "translate(-257.637 -334.484)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16014",
    "data-name": "Trazado 16014",
    d: "M339.725,485.694a2.247,2.247,0,0,1,1.685-3.005l1.176-7.9,3.09,2.769-1.59,7.075a2.259,2.259,0,0,1-4.36,1.058Z",
    transform: "translate(-312.207 -409.282)",
    fill: "#f9735d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16015",
    "data-name": "Trazado 16015",
    d: "M66.217,487.893l2.733-.181.6-10.629-4.034.268Z",
    transform: "translate(-50.878 -370.481)",
    fill: "#f9735d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16016",
    "data-name": "Trazado 16016",
    d: "M0,0H8.609V3.326H3.326A3.326,3.326,0,0,1,0,0Z",
    transform: "translate(23.412 119.707) rotate(180)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16017",
    "data-name": "Trazado 16017",
    d: "M89.789,474.08l2.57.948,4.882-9.461-3.793-1.4Z",
    transform: "translate(-69.726 -360.453)",
    fill: "#f9735d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16018",
    "data-name": "Trazado 16018",
    d: "M0,0H8.609V3.326H3.326A3.326,3.326,0,0,1,0,0Z",
    transform: "translate(26.708 118.791) rotate(-159.739)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16019",
    "data-name": "Trazado 16019",
    d: "M276.668,493.33s2.768,1.491,1.916,7.453l-.852,22.571-4.706,10.289-4.046-1.065,2.576-8.373-3.407-14.693L267.7,536.2l-3.833.639-5.515-44.359,7.027-3.194Z",
    transform: "translate(-249.133 -420.537)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16020",
    "data-name": "Trazado 16020",
    d: "M258.2,375.4l-2.768,4.472-4.046-4.046-7.563,5.294a1.431,1.431,0,0,0-.508,1.708,48.108,48.108,0,0,1,3.28,21.212,24.856,24.856,0,0,1,11.711.213c5.962,1.7,7.453,1.065,7.453,1.065s-1.491-10.86-.639-13.2c.707-1.943,2.146-8.428,2.616-10.583a.971.971,0,0,0-.475-1.055Z",
    transform: "translate(-237.371 -332.103)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16021",
    "data-name": "Trazado 16021",
    d: "M340.225,398.213h0a.973.973,0,0,1,1.075.7l3.6,13.016-.852,7.879-4.046-.639.426-5.536-2.981-7.027,1.968-7.675a.973.973,0,0,1,.8-.722Z",
    transform: "translate(-310.556 -349.807)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16023",
    "data-name": "Trazado 16023",
    d: "M242.7,499.694a2.247,2.247,0,0,0-1.685-3.005l-1.176-7.9-3.09,2.769,1.59,7.075a2.259,2.259,0,0,0,4.36,1.058Z",
    transform: "translate(-232.354 -420.154)",
    fill: "#f9735d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16024",
    "data-name": "Trazado 16024",
    d: "M237.9,400.6h0a1.433,1.433,0,0,0-1.2,1.342l-1.22,24.4h4.472l1.491-12.989-1.9-11.571a1.433,1.433,0,0,0-1.65-1.182Z",
    transform: "translate(-231.372 -351.654)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16025",
    "data-name": "Trazado 16025",
    d: "M38.374,535.142H0v-.471H38.459Z",
    transform: "translate(0 -415.202)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_927",
    "data-name": "Grupo 927",
    transform: "translate(-11606.184 12893.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16173",
    "data-name": "Trazado 16173",
    d: "M2299.739,1491.3s2.131,2.41.96,5.068-2.427-4.828-2.427-4.828Z",
    transform: "translate(-2288.627 -1489.9)",
    fill: "#ada9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16168",
    "data-name": "Trazado 16168",
    d: "M2326.449,1635.819l-.081,4.781s.839,1.389,3.632,1.664a4.953,4.953,0,0,0,2.821-.254l-.249-2.426-.247-2.366-5.031-1.2Z",
    transform: "translate(-2322.503 -1623.592)",
    fill: "#f27e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16169",
    "data-name": "Trazado 16169",
    d: "M2329.161,1638.511c.009.131-.77.542-.7.72,1.03,2.406,4.865,3.616,6.066,3.744l-.339-3.267Z",
    transform: "translate(-2324.371 -1626.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16170",
    "data-name": "Trazado 16170",
    d: "M2301.239,1485.906a4.508,4.508,0,0,1,1.387,2.071c.625,1.845,1.886,6.154,1.06,8.8-1.073,3.433-4.168,2.79-6.009,2.063a6.152,6.152,0,0,1-2.666-1.912,2.6,2.6,0,0,1-2.869-1.133c-1.109-1.676-.329-3.536.679-3.937a2.7,2.7,0,0,1,2.165.364l-.865-1.82s3.483-7.449,7.118-4.49",
    transform: "translate(-2291.034 -1484.27)",
    fill: "#f27e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16174",
    "data-name": "Trazado 16174",
    d: "M2413.986,1588.7a.2.2,0,0,0,.12-.362l-1.746-1.3a.2.2,0,0,0-.24.323l1.746,1.3a.2.2,0,0,0,.12.04",
    transform: "translate(-2410.29 -1578.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16175",
    "data-name": "Trazado 16175",
    d: "M2419.42,1599.75a.207.207,0,0,0,.047-.005l1.424-.341a.2.2,0,0,0,.149-.242.2.2,0,0,0-.242-.149l-1.425.341a.2.2,0,0,0,.047.4",
    transform: "translate(-2417.686 -1589.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16176",
    "data-name": "Trazado 16176",
    d: "M2306.907,1550.274a.21.21,0,0,0,.05-.006.2.2,0,0,0,.145-.244l-.281-1.1a.2.2,0,0,0-.389.1l.281,1.1a.2.2,0,0,0,.195.152",
    transform: "translate(-2295.295 -1543.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16177",
    "data-name": "Trazado 16177",
    d: "M2347.321,1552.425a.192.192,0,0,0,.051-.007.2.2,0,0,0,.144-.244l-.281-1.1a.2.2,0,0,0-.389.1l.281,1.1a.2.2,0,0,0,.194.151",
    transform: "translate(-2338.738 -1545.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16183",
    "data-name": "Trazado 16183",
    d: "M2305.226,1530.577a.2.2,0,0,0,.021-.4l-.907-.1a.2.2,0,0,0-.043.4l.907.1h.022",
    transform: "translate(-2293.44 -1525.774)",
    fill: "#6c6b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16178",
    "data-name": "Trazado 16178",
    d: "M2342.758,1535.14a.2.2,0,0,0,.078-.015l1.233-.516a.2.2,0,1,0-.155-.37l-1.234.516a.2.2,0,0,0,.078.386",
    transform: "translate(-2335.088 -1529.609)",
    fill: "#6c6b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16179",
    "data-name": "Trazado 16179",
    d: "M2311.315,1480.6s.5,1.99.877,1.747.739-3.112.454-4.4-.492-1.93-.492-1.93,5.223-.465,6.6-1.705-1.531-2.042-4.506-1.479a8.624,8.624,0,0,0-4.147,1.681s-1.863-.278-2.56.859.889,5.457.889,5.457.47-1.084,2.886-.234",
    transform: "translate(-2307.364 -1472.649)",
    fill: "#ada9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16180",
    "data-name": "Trazado 16180",
    d: "M2286.547,1588.852s-1.46-1.616-2.2-1.374-1.013,1.329-1.013,1.329-.881-1.221-1.853-.877-3.057.47-3.079.808.582.458.582.458,4.906.567,7.566-.344",
    transform: "translate(-2272.635 -1578.85)",
    fill: "#ada9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16171",
    "data-name": "Trazado 16171",
    d: "M2290.234,1578.688s.087,3.227.025,4.706,4.049,3.787,6.89,2.512,2.062-5,2.062-5l-2.532.234a4.854,4.854,0,0,0-1.247-.468,3.256,3.256,0,0,0-1.547.225Z",
    transform: "translate(-2286.282 -1570.741)",
    fill: "#ada9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16181",
    "data-name": "Trazado 16181",
    d: "M2329.483,1606a.2.2,0,0,0,.021-.4,1.631,1.631,0,0,1-1.181-.728.2.2,0,0,0-.359.18,2.006,2.006,0,0,0,1.5.947h.021",
    transform: "translate(-2319.484 -1594.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16182",
    "data-name": "Trazado 16182",
    d: "M2314.918,1561.8a.2.2,0,0,0,.18-.111,3.154,3.154,0,0,0-.353-2.958.2.2,0,0,0-.33.23,2.8,2.8,0,0,1,.323,2.549.2.2,0,0,0,.18.291",
    transform: "translate(-2304.13 -1552.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16172",
    "data-name": "Trazado 16172",
    d: "M2315.479,1694.824a11.161,11.161,0,0,0,2.577-.3.2.2,0,0,0-.1-.389c-.049.013-4.971,1.247-7.43-1.665a.2.2,0,1,0-.307.259,6.7,6.7,0,0,0,5.261,2.093",
    transform: "translate(-2306.676 -1675.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16184",
    "data-name": "Trazado 16184",
    d: "M12.878,0a2.047,2.047,0,0,1,1.349,1.041,1.217,1.217,0,0,1,.074.581,1.422,1.422,0,0,1-.31.66c-.94,1.124-4.8,1.031-4.8,1.031-2.593-.063-3.968-.243-6.12-.338C1.858,2.921.827,2.913.059,2.918A.059.059,0,0,1,.047,2.8L12.878,0",
    transform: "translate(-0.336 3.356) rotate(-11)",
    fill: "#c6783a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16185",
    "data-name": "Trazado 16185",
    d: "M3.493,0l-1.1,3.39A2.773,2.773,0,0,0,.837,4.637a2.3,2.3,0,0,0-.176.432L.376,4.945a.626.626,0,0,1-.333-.8L1.321.874Z",
    transform: "translate(-1.037 4.865) rotate(-11)",
    fill: "#fae8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16186",
    "data-name": "Trazado 16186",
    d: "M0,8.047a.665.665,0,0,0,.7.683c1.455-.074,2.681-.169,3.613-.252,2.375-.21,1.407-.213,4.19-.5,1.858-.193,2.817-.246,3.8-.966a4.52,4.52,0,0,0,1.1-1.173,7.094,7.094,0,0,0-2.928-4.7A6.886,6.886,0,0,0,6.013.032a6.7,6.7,0,0,0-2.7,1.012C.477,2.912.048,6.5,0,8.047",
    transform: "translate(-1.966 -2.275) rotate(-11)",
    fill: "#f2b05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16187",
    "data-name": "Trazado 16187",
    d: "M0,1.942A6.08,6.08,0,0,1,5.151,1.56,5.594,5.594,0,0,1,7.6,3.643,4.438,4.438,0,0,0,5.6.6,4.33,4.33,0,0,0,1.257.571,2.447,2.447,0,0,0,0,1.942",
    transform: "translate(-0.482 -1.348) rotate(-11)",
    fill: "#c6783a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.f7107b581df14a170c017fcd1be2478f.svg";
export { ForwardRef as ReactComponent };